var $3849d6a9579143d9$exports = {};
$3849d6a9579143d9$exports = {
    "loading": `A carregar...`,
    "placeholder": `Selecionar\u{2026}`
};


export {$3849d6a9579143d9$exports as default};
//# sourceMappingURL=pt-PT.mjs.map
